import React, { memo } from 'react';
export function ResultSeasonal() {
  return <section className="bg-warm-light py-16 md:py-20 px-4" data-id="element-240">
      <div className="max-w-3xl mx-auto text-center" data-id="element-241">
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm mb-3" data-id="element-242">
          Turn everyday moments into beautiful memories
        </p>

        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-243">
          <img src="https://images.unsplash.com/photo-1530281700549-e82e7bf110d6?w=900&h=700&fit=crop&crop=faces" alt="Cozy seasonal dog photo with warm autumn tones, soft cinematic lighting, emotionally rich and frame-worthy" className="w-full h-auto object-cover" data-id="element-244" />
        </div>

        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-245">
          Create photos that feel{' '}
          <span className="font-semibold text-warm-hero" data-id="element-246">
            warm, meaningful, and worth saving
          </span>{' '}
          long after the moment is gone.
        </p>
      </div>
    </section>;
}